import { PayloadAction } from '@reduxjs/toolkit';

import { ERRORProtect } from '@src/types/errors';

import { globalActions, loginActions } from '@modules';
import { TMiddleware, ProtectNextEnum } from '@modules/types';

import { checkActionsType } from './utils';

const { setupOTP } = ProtectNextEnum;

export const protect: TMiddleware = store => next => action => {
  const { login } = store.getState();

  if (
    checkActionsType(action, [
      loginActions.keepAlive.rejected,
      loginActions.resetPasswordPhone.fulfilled,
    ]) &&
    (action as PayloadAction<ERRORProtect>)?.payload.data?.next === setupOTP &&
    !login.protectNext
  ) {
    store.dispatch(globalActions.setProtect('intro2fa'));
  }
  return next(action);
};

export default protect;
